import React, { useState } from 'react'
import { ReactComponent as ArrowTurnUpRight } from '@/assets/icons/arrow-turn-up-right.svg'
// eslint-disable-next-line
import { ReactComponent as CalendarIcon } from '@/assets/icons/calendar-icon.svg'
import { ReactComponent as AddUserIcon } from '@/assets/icons/add-user-icon.svg'
import './BottomHeader.scoped.sass'

import { HumanTime } from '@/components/commons/HumanTime'
import NameSlugPlaceholder from './NameSlugPlaceholder'
import MessageHeadersPanel from './MessageHeadersPanel'
import WritingModalService from '@/app-domains/messages/writing/WritingModal.service'
import writingService from '@/app-domains/messages/draft/writing.service'
import contactsService from '@/app-domains/contacts/contacts.service'
import modalService from '@/services/modal.service'
import CreateContactModal from '@/components/SideMenu/components/ContactMenu/components/CreateContactModal/CreateContactModal'

export function BottomHeader (props) {
  const message = JSON.parse(JSON.stringify(props.message))
  const { fromEmailOnlyName, date, tos, fromEmail, headers } = message
  const emailAdressNamesRefined = tos.join(', ')
  // TODO: Move this to threads service and add it as a message property like "fromContactProfileImage"
  const [contact] = useState(contactsService.findContactByEmail(fromEmail) || contactsService.getPersonalInfoIfMailComesFromCustomer(fromEmail))
  const [forceLoadSlugPlaceholder, setForceSlugPlaceholder] = useState(false)

  const getGenericProfileImage = () => <div className="-img">
    { message.senderFaviconUrl?.length > 0 && !forceLoadSlugPlaceholder
      ? <img src={message.senderFaviconUrl} onError={() => setForceSlugPlaceholder(true)} className="favicon-img"></img>
      : fromEmailOnlyName && fromEmailOnlyName.length > 0
        ? <NameSlugPlaceholder name={fromEmailOnlyName}/>
        : <img src="https://via.placeholder.com/40" className="senderInformationPhotoStyle"></img>
      }
  </div>

  const getProfileImage = () => <div className="-img" onClick={() => contact && contactsService.travelToContactViewAndFocusContact(contact)}>
    { contact?.contactimageuri && !forceLoadSlugPlaceholder
      ? <img className='contact-image-img' src={contact.contactimageuri} onError={() => setForceSlugPlaceholder(true)}/>
      : <NameSlugPlaceholder name={
            contactsService.buildContactFullname(contact)
        }/>}
  </div>

  const openForwardModal = () => {
    writingService.setForwardBaseData(props.message, props.thread)
    WritingModalService.openForward(props.message, props.thread)
  }

  return <div className="bottom-header">
    <div className="bottom-header-left">
      <div className="avatar-contact">
        {contact ? getProfileImage() : getGenericProfileImage()}
      </div>
      <div className="message-info">
        <div className="contact-name">
          {contact ? contactsService.buildContactFullname(contact) || fromEmailOnlyName : fromEmailOnlyName }
          {!contact?.itsMe && !contactsService.findContactByEmail(fromEmail) && (
            <span className='contact-actions' onClick={() => modalService.open(
              <CreateContactModal type='new' dataToFillInCreationForm={{ emails: [fromEmail], firstname: fromEmailOnlyName }}/>, true
            )}>
              <AddUserIcon style={{ width: 14, height: 14 }}/>
            </span>
          )}
        </div>
        
        <div className="recipients">
          <div className='email-adress-names' title={`To: ${emailAdressNamesRefined}`}>
            To: {emailAdressNamesRefined}
          </div>
          <MessageHeadersPanel headers={headers} />
        </div>
      </div>
    </div>
    <div className="bottom-header-right">
      <div className="date">
        <HumanTime date={date}/>
      </div>
      <div className="buttons">
        <button onClick={openForwardModal}>
          <ArrowTurnUpRight />
        </button>
        { /* <button className="disabled">
          <CalendarIcon />
        </button> */ }
      </div>
    </div>
  </div>
}
